import { Model } from './model';
// import {TestbedOwner} from "./testbed-owner";

export class BillingSetup extends Model {

  id?: number;
  addressLine1?: string;
  city?: string;
  codeSDI?: string;
  country?: string;
  description?: string;
  email?: string;
  identifier?: string;
  pec?: string;
  phone?: string;
  vatNumber?: string;
  zipCode?: string;
  contractId?: number;
  month?: number;
  type?: number;
  billingItems?: []
}
